// import {
//   createContext,
//   useContext,
//   useState,
//   ReactNode,
//   useEffect,
// } from "react";
// import { jwtDecode } from "jwt-decode";
// import { Preferences } from "@capacitor/preferences";
// import { LocalNotifications } from "@capacitor/local-notifications";
// import { login as apiLogin, register as apiRegister } from "../api/auth";
// import api from "../api/api";

// type UserType = {
//   id: string;
//   name: string;
//   email: string;
//   role: "admin" | "hr head" | "manager" | "employee" | "supervisor" | "director" | "founder";
//   managerID?: string;
// };

// type AuthContextType = {
//   isAuthenticated: boolean;
//   user: UserType | null;
//   login: (email: string, password: string) => Promise<void>;
//   register: (email: string, password: string) => Promise<void>;
//   logout: () => void;
//   clockOut: () => void;
// };

// const AuthContext = createContext<AuthContextType | null>(null);

// export function AuthProvider({ children }: { children: ReactNode }) {
//   // console.log("AuthContext: AuthProvider component initializing");
//   const [isAuthenticated, setIsAuthenticated] = useState(() => {
//     const token = localStorage.getItem("accessToken");
//     // console.log("AuthContext: Checking for existing token:", !!token);
//     return !!token;
//   });

//   const [user, setUser] = useState<UserType | null>(() => {
//     const storedUser = localStorage.getItem("user");
//     return storedUser ? JSON.parse(storedUser) : null;
//   });

//   let refreshInterval;

//   const startTokenRefresh = () => {
//     stopTokenRefresh();

//     refreshInterval = setInterval(async () => {
//       try {
//         const response = await api.post("/api/auth/refresh");
//         if (response.data.accessToken) {
//           localStorage.setItem("accessToken", response.data.accessToken);
//         }

//         console.log("Token refreshed at:", new Date().toLocaleTimeString());
//       } catch (error) {
//         console.error("Auto refresh failed:", error);
//         window.location.href = "/login";
//       }
//     }, 3600000); //  (1hr)
//   };

//   const stopTokenRefresh = () => {
//     if (refreshInterval) {
//       clearInterval(refreshInterval);
//       refreshInterval = null;
//     }
//   };

//   useEffect(() => {
//     startTokenRefresh();
//     return () => stopTokenRefresh();
//   }, []);

//   // console.log("AuthContext: Initial authentication state:", isAuthenticated);

//   const login = async (email: string, password: string) => {
//     try {
//       // console.log("AuthContext: Starting login process for:", email);
//       const response = await apiLogin(email, password);
//       console.log("AuthContext: Login response received:", response);

//       if (response?.access_token) {
//         // console.log("AuthContext: Valid response received, storing tokens");
//         localStorage.setItem("accessToken", response.access_token);
//         if (response.refreshToken) {
//           localStorage.setItem("refreshToken", response.refreshToken);
//           // console.log("AuthContext: Refresh token stored");
//         }
//         if (response?.access_token) {
//           const decodedUser = jwtDecode(response.access_token);
//           localStorage.setItem("user", JSON.stringify(decodedUser));
//           setUser(decodedUser); // Also update state
//         }
//         setIsAuthenticated(true);
//       } else {
//         console.error("AuthContext: Invalid response format:", response);
//         throw new Error(
//           response?.message || "Login failed - invalid response format",
//         );
//       }
//     } catch (error) {
//       console.error("AuthContext: Login error:", error);
//       localStorage.removeItem("refreshToken");
//       localStorage.removeItem("accessToken");
//       setIsAuthenticated(false);
//       console.log("AuthContext: Authentication state reset to false");
//       const errorMessage =
//         error instanceof Error && error.message
//           ? error.message
//           : "Login failed";
//       throw new Error(errorMessage);
//     }
//   };

//   const register = async (email: string, password: string, role: string,first_name: string,
//   last_name: string) => {
//     try {
//       // console.log("AuthContext: Starting registration process for:", email, "with role:", role);
//       const response = await apiRegister(email, password, role, first_name, last_name); //  include role in API call
//       // console.log("AuthContext: Registration response received:", response);

//       if (!response?.success) {
//         // console.error("AuthContext: Registration failed:", response?.message);
//         throw new Error(response?.message || "Registration failed");
//       }

//       // console.log("AuthContext: Registration completed successfully");
//       // Don't authenticate yet – login after register
//     } catch (error: any) {
//       console.error("AuthContext: Registration error:", error);
//       throw new Error(error?.message || "Registration failed");
//     }
//   };

//   async function showNotification() {
//     await LocalNotifications.schedule({
//       notifications: [
//         {
//           title: "Attendance Marked ✅",
//           body: "You have successfully clocked out",
//           id: 1,
//           schedule: { at: new Date(Date.now() + 1000) },
//         },
//       ],
//     });
//   }

//   async function showNotification1() {
//     await LocalNotifications.schedule({
//       notifications: [
//         {
//           title: "Attendance Marked ❌",
//           body: "You have not clocked out yet , Please try again",
//           id: 1,
//           schedule: { at: new Date(Date.now() + 1000) },
//         },
//       ],
//     });
//   }

//   const clockOut = async () => {
//     const { keys } = await Preferences.keys();
//     const allData = {};
//     for (const key of keys) {
//       const { value } = await Preferences.get({ key });
//       allData[key] = value;
//     }
//     const data = { ...allData, clockIn: false };
//     const res = await api.post("/attendance", data);
//     if (res.status === 200) {
//       showNotification(); // 🔥 yahi call karo
//     } else {
//       showNotification1();
//     }
//   };

//   const logout = async () => {
//     console.log("AuthContext: Logging out userssss");
//     localStorage.removeItem("refreshToken");
//     localStorage.removeItem("accessToken");
//     await Preferences.remove({ key: "level" });
//     await Preferences.remove({ key: "employee_id" });
//     await Preferences.remove({ key: "branchID" });
//     await Preferences.remove({ key: "headOfficeID" });
//     await Preferences.remove({ key: "masterID" });
//     await Preferences.remove({ key: "fcmtoken" });
//     await Preferences.remove({ key: "workfromhome" });

//     await Preferences.remove({ key: "workingHoursStart1" });
//     await Preferences.remove({ key: "workingHoursEnd1" });
//     await Preferences.remove({ key: "maxDistance1" });
//     await Preferences.remove({ key: "officeLon1" });
//     await Preferences.remove({ key: "officeLat1" });

//     await Preferences.remove({ key: "workingHoursStart2" });
//     await Preferences.remove({ key: "workingHoursEnd2" });
//     await Preferences.remove({ key: "maxDistance2" });
//     await Preferences.remove({ key: "officeLon2" });
//     await Preferences.remove({ key: "officeLat2" });

//     await Preferences.remove({ key: "workingHoursStart3" });
//     await Preferences.remove({ key: "workingHoursEnd3" });
//     await Preferences.remove({ key: "maxDistance3" });
//     await Preferences.remove({ key: "officeLon3" });
//     await Preferences.remove({ key: "officeLat3" });
//     await Preferences.remove({key: "user"});

//     // setIsAuthenticated(false);
//     // window.location.href = "/";
//     setUser(null);                 
//     setIsAuthenticated(false);
//     localStorage.removeItem("user");
//     // console.log("AuthContext: Logout completed, reloading page");
//     // window.location.reload();
//   };

//   // console.log("AuthContext: Rendering AuthProvider with authentication state:", isAuthenticated);
//   return (
//     <AuthContext.Provider
//       value={{ isAuthenticated, user, login, register, logout, clockOut }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// }

// export function useAuth() {
  
//   // console.log("AuthContext: useAuth hook called");
//   const context = useContext(AuthContext);

//   if (!context) {
//     // console.error("AuthContext: useAuth called outside of AuthProvider");
//     throw new Error("useAuth must be used within an AuthProvider");
//   }
//   // console.log("AuthContext: useAuth returning context with isAuthenticated:", context.isAuthenticated);
//   return context;
// }


// AuthContext.tsx - FULLY FIXED VERSION

import {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from "react";
import { jwtDecode } from "jwt-decode";
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import { LocalNotifications } from "@capacitor/local-notifications";
import axios from "axios";
import { loginSelect as apiLogin, register as apiRegister } from "../api/auth";
import api from "../api/api";
import {
  bootstrapSessionFromOtherTabs,
  initSessionSyncResponder,
  persistSessionBackup,
  clearSessionBackup,
} from "../utils/sessionStore";

type UserType = {
  id: string;
  name: string;
  email: string;
  role:
    | "superadmin"
    | "admin"
    | "hr head"
    | "hr admin"
    | "manager"
    | "employee"
    | "intern"
    | "supervisor"
    | "director"
    | "founder"
    | "client"
    | "vendor";
  managerID?: string;
  profile_photo_url?: string | null;
  subscription?: {
    plan: "starter" | "professional" | "enterprise";
    status: "active" | "trialing" | "sales_pending";
    employee_limit: number | null;
    trial_end?: string | null;
    workspace_mode: "limited" | "full";
  };
};

type AuthContextType = {
  isAuthenticated: boolean;
  user: UserType | null;
  loginSelect: (email: string, password: string, head_office_id: string) => Promise<UserType>;
  register: (
    email: string,
    password: string,
    role: string,
    first_name: string,
    last_name: string,
    mobile: string,
    company_name?: string,
    plan?: "starter" | "professional" | "enterprise"
  ) => Promise<void>;
  logout: () => Promise<void>;
  clockOut: () => void;
  setUserPhoto: (url: string | null) => void;
  setUserName: (name: string) => void;
};

// ✅ Helper functions - platform check ek jagah
const isNative = () => Capacitor.isNativePlatform();

// Web uses sessionStorage so each tab is its own session (different org per
// tab, isolated logout). Native keeps Preferences. See utils/sessionStore.ts.
const saveToStorage = async (key: string, value: string) => {
  if (isNative()) {
    await Preferences.set({ key, value });
  } else {
    sessionStorage.setItem(key, value);
  }
};

const getFromStorage = async (key: string): Promise<string | null> => {
  if (isNative()) {
    const { value } = await Preferences.get({ key });
    return value;
  } else {
    return sessionStorage.getItem(key);
  }
};

const removeFromStorage = async (key: string) => {
  if (isNative()) {
    await Preferences.remove({ key });
  } else {
    sessionStorage.removeItem(key);
    // Drop any legacy shared copy a pre-sessionStorage build left in localStorage.
    localStorage.removeItem(key);
  }
};

const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<UserType | null>(null);
  const [loading, setLoading] = useState(true);
  let refreshInterval: NodeJS.Timeout | null = null;

  // ✅ Auth check on app start
  useEffect(() => {
    // Answer other tabs' session-sync requests for this tab's lifetime, so a
    // newly opened tab can inherit our session (web only; no-op on native).
    initSessionSyncResponder();

    // True when a JWT is missing/undecodable or already past its exp.
    const isTokenExpired = (tok: string | null): boolean => {
      if (!tok) return true;
      try {
        const p: any = jwtDecode(tok);
        return !p?.exp || p.exp * 1000 <= Date.now();
      } catch {
        return true;
      }
    };

    const checkAuth = async () => {
      try {
        // A brand-new (empty) tab inherits an already-signed-in tab's session
        // once, here, before we decide it's logged out — so opening a new tab
        // no longer dumps the user on the landing/login page. Each tab stays
        // independent afterwards (logout / login as a different user only
        // affects the tab it happens in). No-op on native or if this tab
        // already has a session (e.g. a same-tab refresh).
        await bootstrapSessionFromOtherTabs();

        let token = await getFromStorage("accessToken");
        const userStr = await getFromStorage("user");

        // An INHERITED token can be stale (an older tab refreshed its own token
        // but the shared backup lagged) → every API call would 401. If the
        // access token is expired, mint a fresh one from the (long-lived,
        // non-rotating) refresh token BEFORE rendering the app — the same
        // mechanism a fresh login relies on. If that's impossible, fall through
        // to a clean logged-out state instead of a broken 401 dashboard.
        if (token && userStr && isTokenExpired(token)) {
          const refreshToken = await getFromStorage("refreshToken");
          let refreshed = false;
          if (refreshToken) {
            try {
              // Bare axios (not the `api` instance) so this skips the
              // request/response interceptors — no stale Bearer header, no
              // interceptor-driven refresh loop or auto-redirect. Hits the same
              // API origin as `api`.
              const resp = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL || ""}/api/auth/refresh`,
                { refreshToken }
              );
              const at = resp?.data?.accessToken;
              if (at) {
                await saveToStorage("accessToken", at);
                persistSessionBackup();
                token = at;
                refreshed = true;
              }
            } catch (e) {
              console.warn("Startup token refresh failed:", e);
            }
          }
          if (!refreshed) {
            // Stale session we can't revive → clear it (incl. its backup) so the
            // tab shows the login page rather than 401-ing on every request.
            clearSessionBackup(token);
            await clearAllStorage();
            token = null;
          }
        }

        if (token && userStr) {
          const userData = JSON.parse(userStr);
          setUser(userData);
          setIsAuthenticated(true);
        }
      } catch (error) {
        console.error("Auth check failed:", error);
        // Kuch bhi galat hua to clean slate
        await clearAllStorage();
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  // ✅ Token refresh
  const startTokenRefresh = () => {
    stopTokenRefresh();
    refreshInterval = setInterval(async () => {
      try {
        const refreshToken = await getFromStorage("refreshToken");
        if (!refreshToken) return; // no refresh token issued — nothing to do
        const response = await api.post("/api/auth/refresh", { refreshToken });
        if (response.data.accessToken) {
          await saveToStorage("accessToken", response.data.accessToken);
          // Keep the persisted backup's token fresh too.
          persistSessionBackup();
        }
      } catch (error) {
        console.error("Auto refresh failed:", error);
        await logout();
      }
    }, 3600000);
  };

  const stopTokenRefresh = () => {
    if (refreshInterval) {
      clearInterval(refreshInterval);
      refreshInterval = null;
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      startTokenRefresh();
    }
    return () => stopTokenRefresh();
  }, [isAuthenticated]);

  // ✅ Saari keys ek jagah clear karo
  const clearAllStorage = async () => {
    const keys = [
      "accessToken", "refreshToken", "user", "level", "employee_id",
      "branchID", "headOfficeID", "masterID", "fcmtoken", "workfromhome",
      "workingHoursStart1", "workingHoursEnd1", "maxDistance1",
      "officeLon1", "officeLat1", "workingHoursStart2", "workingHoursEnd2",
      "maxDistance2", "officeLon2", "officeLat2", "workingHoursStart3",
      "workingHoursEnd3", "maxDistance3", "officeLon3", "officeLat3",
    ];
    for (const key of keys) {
      await removeFromStorage(key);
    }
  };

  const loginSelect = async (email: string, password: string, head_office_id: string) => {
    try {
      const response = await apiLogin(email, password, head_office_id);

      if (response?.access_token) {
        await saveToStorage("accessToken", response.access_token);

        const refreshToken = response.refresh_token ?? response.refreshToken;
        if (refreshToken) {
          await saveToStorage("refreshToken", refreshToken);
        }

        const decodedUser = jwtDecode(response.access_token) as UserType;
        await saveToStorage("user", JSON.stringify(decodedUser));

        // Persist this login so a full close+reopen (or a brand-new tab with no
        // live tab to inherit from) restores it and lands on the dashboard.
        persistSessionBackup();

        setUser(decodedUser);
        setIsAuthenticated(true);
        return decodedUser;
      } else {
        throw new Error(response?.message || "Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  };

  const register = async (
    email: string,
    password: string,
    role: string,
    first_name: string,
    last_name: string,
    mobile: string,
    company_name?: string,
    plan: "starter" | "professional" | "enterprise" = "starter"
  ) => {
    try {
      const response = await apiRegister(email, password, role, first_name, last_name, mobile, company_name, plan);
      if (!response?.success) {
        throw new Error(response?.message || "Registration failed");
      }
    } catch (error: any) {
      throw new Error(error?.message || "Registration failed");
    }
  };

  const clockOut = async () => {
    const { keys } = await Preferences.keys();
    const allData: Record<string, any> = {};
    for (const key of keys) {
      const { value } = await Preferences.get({ key });
      allData[key] = value;
    }
    const data = { ...allData, clockIn: false };
    const res = await api.post("/attendance", data);
    // Leaving before the shift ends can be approval-based (Settings -> Policy
    // Rules). The punch is REFUSED with a 200 and a status, so a plain
    // status-code check would cheerfully announce a clock-out that never
    // happened — and the employee would find out at payroll.
    if (res.data?.result?.status === "approval_required") {
      await LocalNotifications.schedule({
        notifications: [{
          title: "Approval needed ⏳",
          body:
            res.data.result.message ||
            "Leaving early needs approval. Open Attendance to send the request.",
          id: 1,
          schedule: { at: new Date(Date.now() + 1000) },
        }],
      });
    } else if (res.status === 200) {
      await LocalNotifications.schedule({
        notifications: [{
          title: "Attendance Marked ✅",
          body: "You have successfully clocked out",
          id: 1,
          schedule: { at: new Date(Date.now() + 1000) },
        }],
      });
    } else {
      await LocalNotifications.schedule({
        notifications: [{
          title: "Attendance Marked ❌",
          body: "You have not clocked out yet, Please try again",
          id: 1,
          schedule: { at: new Date(Date.now() + 1000) },
        }],
      });
    }
  };

  const logout = async () => {
    // Drop the persisted backup for THIS session before wiping storage, so an
    // explicit logout doesn't auto-restore on reopen. Passing the current token
    // means logging out one user won't wipe a different user's still-active
    // login that another tab persisted.
    const token = await getFromStorage("accessToken");
    clearSessionBackup(token);
    await clearAllStorage();
    setUser(null);
    setIsAuthenticated(false);
    stopTokenRefresh();
  };

  const setUserPhoto = (url: string | null) => {
    setUser((prev) => {
      if (!prev) return prev;
      const next = { ...prev, profile_photo_url: url };
      saveToStorage("user", JSON.stringify(next));
      persistSessionBackup(); // keep the persisted copy's user in sync
      return next;
    });
  };

  const setUserName = (name: string) => {
    setUser((prev) => {
      if (!prev) return prev;
      const next = { ...prev, name };
      saveToStorage("user", JSON.stringify(next));
      persistSessionBackup(); // keep the persisted copy's user in sync
      return next;
    });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, user, loginSelect, register, logout, clockOut, setUserPhoto, setUserName }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
